import React from 'react';

const Footer = () => {
  return (
    <footer className="site-footer bg-dark text-white pt-5 pb-4 position-relative border-top" style={{ backgroundColor: '#0b132b' }}>
      <div className="container">
        <div className="row g-4 justify-content-between pb-4 border-bottom border-secondary border-opacity-25">
          {/* Brand Info */}
          <div className="col-lg-4 col-md-6">
            <div className="d-flex align-items-center gap-2 mb-3">
              <img
                src="/logo192.png"
                alt="A.B. Engineering Works Logo"
                width="44"
                height="44"
                className="bg-white rounded-circle p-1"
              />
              <div>
                <h5 className="fw-bold text-white mb-0 fs-5">A.B. Engineering Works</h5>
                <span className="text-white-50 small">Pharmaceutical Machinery Spares</span>
              </div>
            </div>
            <p className="text-white-50 small mb-3" style={{ lineHeight: '1.6' }}>
              Specialized manufacturer of high-precision stainless steel burners, gripping chucks, hardened drive shafts, and custom tooling for pharmaceutical ampoule and vial packaging lines since 1997.
            </p>
            <div className="d-flex flex-wrap gap-2">
              <span className="badge bg-white bg-opacity-10 text-white border border-secondary border-opacity-25 px-2 py-1 small">
                Est. 1997
              </span>
              <span className="badge bg-primary text-white px-2 py-1 small">
                ±0.005mm Precision
              </span>
              <span className="badge bg-success text-white px-2 py-1 small">
                25+ Pharma Partners
              </span>
              {/* <span
                className="badge px-2.5 py-1.5 small d-inline-flex align-items-center gap-1.5 fw-semibold"
                style={{
                  background: 'rgba(212, 175, 55, 0.12)',
                  color: '#f3c94c',
                  border: '1px solid rgba(212, 175, 55, 0.35)'
                }}
              >
                <img src="/msme-gold-pure.png" alt="MSME Logo" width="14" height="16" className="object-fit-contain" />
                MSME Registered
              </span> */}
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h6 className="fw-bold text-white text-uppercase small mb-3 tracking-wide">Quick Navigation</h6>
            <ul className="list-unstyled d-flex flex-column gap-2 small mb-0">
              <li>
                <a href="#home" className="text-white-50 text-decoration-none hover-white">Home</a>
              </li>
              <li>
                <a href="#about" className="text-white-50 text-decoration-none hover-white">About Facility</a>
              </li>
              <li>
                <a href="#products" className="text-white-50 text-decoration-none hover-white">Machinery Spares</a>
              </li>
              <li>
                <a href="#expertise" className="text-white-50 text-decoration-none hover-white">Core Expertise</a>
              </li>
              <li>
                <a href="#why-us" className="text-white-50 text-decoration-none hover-white">Why Choose Us</a>
              </li>
              <li>
                <a href="#contact" className="text-white-50 text-decoration-none hover-white">Contact &amp; RFQ</a>
              </li>
            </ul>
          </div>

          {/* Spare Parts Range */}
          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold text-white text-uppercase small mb-3 tracking-wide">Featured Spares</h6>
            <ul className="list-unstyled d-flex flex-column gap-2 small text-white-50 mb-0">
              <li><i className="fas fa-angle-right text-primary me-2"></i>All Types of Burners (SS 310S)</li>
              <li><i className="fas fa-angle-right text-primary me-2"></i>Upper &amp; Lower Chuck Spares</li>
              <li><i className="fas fa-angle-right text-primary me-2"></i>Hardened Drive Shafts (EN24/EN19)</li>
              <li><i className="fas fa-angle-right text-primary me-2"></i>SM-3 Machine Spares &amp; Cams</li>
              <li><i className="fas fa-angle-right text-primary me-2"></i>Device Assemblies &amp; Forming Tooling</li>
              <li><i className="fas fa-angle-right text-primary me-2"></i>Emergency Reverse Engineering</li>
            </ul>
          </div>

          {/* Workshop Contact */}
          <div className="col-lg-3 col-md-6">
            <h6 className="fw-bold text-white text-uppercase small mb-3 tracking-wide">Workshop Desk</h6>
            <div className="d-flex flex-column gap-2 small text-white-50">
              <div className="d-flex gap-2 align-items-start">
                <i className="fas fa-map-marker-alt text-danger mt-1"></i>
                <span>A - 1/2, Shivaji Industrial Estate, Chhabra Compound, Vakola Bridge, Santacruz East, Mumbai - 400055</span>
              </div>
              <div className="d-flex gap-2 align-items-center mt-1">
                <i className="fas fa-phone-alt text-primary"></i>
                <a href="tel:+918108765006" className="text-white text-decoration-none hover-white">+91 8108765006</a>
                <span>/</span>
                <a href="tel:+919819214375" className="text-white text-decoration-none hover-white">+91 9819214375</a>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <i className="fas fa-envelope text-info"></i>
                <a href="mailto:abengworks@yahoo.in" className="text-white text-decoration-none hover-white">abengworks@yahoo.in</a>
              </div>
              <div className="mt-2">
                <a
                  href="https://wa.me/918108765006"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-success text-white fw-semibold d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill shadow-xs"
                >
                  <i className="fab fa-whatsapp"></i>
                  <span>WhatsApp Inquiry</span>
                </a>
              </div>

              {/* Premium Executive MSME Accreditation Card */}
              <div
                className="mt-3 p-3 rounded-3 position-relative overflow-hidden shadow-sm"
                style={{
                  background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.08) 0%, rgba(15, 23, 42, 0.7) 100%)',
                  border: '1px solid rgba(212, 175, 55, 0.35)',
                  backdropFilter: 'blur(8px)'
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  {/* Glowing Gold Halo Ring with MSME Emblem */}
                  <div
                    className="d-flex align-items-center justify-content-center flex-shrink-0 rounded-circle"
                    style={{
                      width: '46px',
                      height: '46px',
                      background: 'radial-gradient(circle, rgba(212, 175, 55, 0.22) 0%, rgba(212, 175, 55, 0.06) 65%, transparent 100%)',
                      border: '1px solid rgba(212, 175, 55, 0.45)',
                      boxShadow: '0 0 12px rgba(212, 175, 55, 0.15)'
                    }}
                  >
                    <img
                      src="/msme-gold-pure.png"
                      alt="Ministry of MSME Govt of India"
                      width="32"
                      height="36"
                      className="object-fit-contain"
                    />
                  </div>

                  {/* Recognition Text Hierarchy */}
                  <div className="lh-sm">
                    <div className="d-flex align-items-center gap-1.5 mb-1">
                      <span
                        className="badge text-dark fw-bold px-2 py-0.5 rounded-pill text-uppercase"
                        style={{ backgroundColor: '#e5b842', fontSize: '0.62rem', letterSpacing: '0.5px' }}
                      >
                        Udyam Certified
                      </span>
                      <span className="text-white-50" style={{ fontSize: '0.68rem' }}>Govt. of India</span>
                    </div>
                    <div className="text-white fw-bold small">
                      Ministry of MSME Registered
                    </div>
                    <div className="text-white-50 mt-1" style={{ fontSize: '0.7rem' }}>
                      Govt. Recognized Manufacturing Unit
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Copyright & Standards */}
        <div className="pt-4 d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 text-xs text-white-50 text-center text-md-start">
          <div>
            &copy; 1997 – 2027 <strong>A.B. Engineering Works</strong>. All rights reserved.
          </div>
          <div className="d-flex flex-wrap gap-2 gap-sm-3 align-items-center justify-content-center text-center">
            <span>Precision Engineering Excellence</span>
            <span className="d-none d-sm-inline">•</span>
            <span>ISO 9001:2015 Compliant</span>
            <span className="d-none d-sm-inline">•</span>
            <span>Santacruz East, Mumbai, India</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
